import ValidatorFunctions from "../validation/ValidatorFunctions"

const customizationConfiguration = {
    namespaced: true,
    state:      {
        currentPosition: {}
    },
    getters:    {
        hasCurrentPosition: state => {
            return !ValidatorFunctions.isEmpty(state.currentPosition)
        },
    },
    mutations:  {
        updateCurrentPosition: function (state, position) {
            state.currentPosition = position
        },
    }
}

export default customizationConfiguration
